export default "__VITE_ASSET__8e9621af__"